var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWildfireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 30,
    r: 20,
    fill: "#d73502"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20 100 L 50 60 L 20 60 Z",
    fill: "#a8c090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 60 L 80 100 L 80 60 Z",
    fill: "#2d5a4d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 60 L 35 100 L 65 100 Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildfireIcon);
export default __webpack_public_path__ + "static/media/wildfire-icon.dbfd1f7969d4fedb39c81b0598706440.svg";
export { ForwardRef as ReactComponent };